import { useTranslation } from "react-i18next";

export const useTranslateGetObject = (key) => {
  const { t } = useTranslation()
  return t(key, { returnObjects: true });
}